import React, { useState, useEffect } from "react";
import {
    Form,
    message,
    Typography,
    Space
} from "antd";
import "../../../style/sample.css";
import GenericModal from "../../buttons/genericModal";
import { toPrice } from "../../../helpers/stringFormat";
import TransactionTableFilters from "./transactionTableFilters";
import { backendPatchWithoutRefresh } from "../../../helpers/callBackend";
// import GenericTableOnRowOnClick from "../../tables/genericTableOnRowOnClick";
import GenericTableOnRowOnClick1 from "../../tables/genericTableOnRowOnClick1";
import TransactionsDrawerSimple from "./transactionsDrawerSimple";
import GenericDropdown from "../../generic/genericDropdown";
import Button from '@mui/material/Button';
import moment from "moment";


const AchDebitRequests = (props) => {
    const [showAchDebitRequests, setShowAchDebitRequests] = useState([...props.achDebitRequests]);
    const [visibleCancelModal, setVisibleCancelModal] = useState(false);
    const [cancelRequestId, setCancelRequestId] = useState("");
    const [dateRangeFilter, setDateRangeFilter] = useState(null);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [selectedAchDebitRequestData, setSelectedAchDebitRequestData] = useState(null);

    useEffect(() => {
        setShowAchDebitRequests([...props.achDebitRequests]);
    }, [props.achDebitRequests]);

    const handleSearch = (e) => {
        if (e.target.value === "") {
            setShowAchDebitRequests(props.achDebitRequests);
        } else {
            let search_text = e.target.value;
            let data = props.achDebitRequests;
            let resData = data.filter(item => {
                let prop_name1 = item.payee_info.memo + " | " + item.payee_info.name;
                let prop_name2 = item["timestamp"];
                let prop_name3 = item["amount"];
                return (
                    prop_name1.toLowerCase().indexOf(search_text.toLowerCase()) > -1 ||
                    prop_name2.toLowerCase().indexOf(search_text.toLowerCase()) > -1 ||
                    prop_name3.toLowerCase().indexOf(search_text.toLowerCase()) > -1
                );
            });
            setShowAchDebitRequests(resData);
        }
    };

    const handleDateFilter = (value) => {
        if (value && value.length === 2) {
            let start_date = value[0].format("YYYY-MM-DD");
            let end_date = value[1].format("YYYY-MM-DD");
            let data = props.achDebitRequests;
            let resData = data.filter(item => {
                let txn_date = item['timestamp'].split("T")[0];
                return txn_date >= start_date && txn_date <= end_date;
            });
            setShowAchDebitRequests(resData);
            setDateRangeFilter(value);
        } else {
            setShowAchDebitRequests(props.achDebitRequests);
        }
    };

    const cancelRequest = (requestId) => {
        backendPatchWithoutRefresh(
            "/api/payments/ach-debit/",
            { 'cancel_ach_debit_request_id': requestId },
        ).then((response) => {
            if (response.status === 200) {
                let newShowAchDebitRequests = showAchDebitRequests.filter((request) => request.id !== requestId);
                setShowAchDebitRequests(newShowAchDebitRequests);
                props.cancelAchDebitRequest(requestId);
            }
        });
    };

    const handleExpand = (expanded, record) => {
        if (expanded) {
            setSelectedAchDebitRequestData({
                "CREATED AT": record.timestamp
                    ? moment(record.timestamp).format("MMMM Do, YYYY") : "N/A",
                "STATUS": record.status
                    ? record.status : "N/A",
                "IS LIVE LINK": record.is_live_link ? "YES" : "NO",
                "URL": record.url ? record.url : "N/A",
                "IS PAID": record.is_paid ? "YES" : "NO",
                "PAYEE NAME": record.payee_info.name
                    ? record.payee_info.name : "N/A",
                "PAYEE MEMO": record.payee_info.memo
                    ? record.payee_info.memo : "N/A",
            });
            setExpandedRowKeys([record.id]);
        } else {
            setExpandedRowKeys([]);
        }
    };

    const table_columns = [
        {
            field: 'timestamp',
            headerName: 'Date',
            flex: 1.5,
            sortable: true,
            sortComparator: (v1, v2) => v1?.localeCompare(v2),
            renderCell: (params) => (
                <span>{params?.row?.timestamp?.slice(0, 10)}</span>
            ),
        },
        {
            field: 'name',
            headerName: 'Description',
            flex: 3,
            sortable: false,
            valueGetter: (params) => {
                const memo = params?.row?.payee_info?.memo || '';
                const name = params?.row?.payee_info?.name || '';
                return `${memo} | ${name}`;
            },
            sortComparator: (v1, v2) => {
                return v1.localeCompare(v2); // Compare the computed 'memo | name' values
            },
            renderCell: (params) => (
                <p style={{ textTransform: 'capitalize' }}>
                    {params?.row?.payee_info?.memo + " | " + params?.row?.payee_info?.name}
                </p>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1.5,
            renderCell: (params) => (
                <p style={{ textTransform: 'capitalize' }}>
                    {params?.row?.status}
                </p>
            ),
        },
        {
            field: 'method',
            headerName: 'Method',
            flex: 1.5,
            renderCell: () => (
                <p style={{ textTransform: 'capitalize' }}>
                    ACH
                </p>
            ),
        },
        {
            field: 'amount',
            headerName: 'Amount',
            flex: 2,
            renderCell: (params) => (
                <span style={{ color: '' }}>
                    {toPrice(params?.row?.amount)}
                </span>
            ),
        },
        {
            field: 'action',
            headerName: '',
            flex: 0.5,
            align: 'right',
            renderCell: (params) => (
                <GenericDropdown
                    dropdownItems={[
                        params?.row?.is_live_link && (
                            <div
                                style={{
                                    color: '#0096FF',
                                    cursor: 'pointer',
                                }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    navigator.clipboard.writeText(params?.row?.url);
                                    message.success('Link copied to clipboard.');
                                }}
                            >
                                Copy Link
                            </div>
                        ),
                        <div
                            style={{ color: 'red', cursor: 'pointer' }}
                            onClick={(event) => {
                                event.stopPropagation();
                                setVisibleCancelModal(true);
                                setCancelRequestId(params?.row?.id);
                            }}
                        >
                            Cancel
                        </div>,
                    ]}
                />
            ),
        },
    ];


    // const table_columns = [
    //     {
    //         title: "Date",
    //         dataIndex: "timestamp",
    //         width: "15%",
    //         render: (text, record) => <span>{record.timestamp.slice(0, 10)}</span>,
    //         defaultSortOrder: "descend",
    //         sorter: (a, b) => a['timestamp']?.localeCompare(b['timestamp']),
    //     },
    //     {
    //         title: "Description",
    //         width: "30%",
    //         render: (_, record) => (
    //             <p style={{ textTransform: "capitalize" }}>
    //                 {record.payee_info?.memo + " | " + record.payee_info?.name}
    //             </p>
    //         ),
    //     },
    //     {
    //         title: "Status",
    //         width: "15%",
    //         render: (_, record) => (
    //             <p style={{ textTransform: "capitalize" }}>
    //                 {record.status}
    //             </p>
    //         ),
    //     },
    //     {
    //         title: "Methooood",
    //         width: "15%",
    //         render: (_, record) => (
    //             <p style={{ textTransform: "capitalize" }}>
    //                 ACH
    //             </p>
    //         ),
    //     },
    //     {
    //         title: "Amount",
    //         width: "20%",
    //         align: "right",
    //         render: (_, record) => (
    //             <span style={{ color: "" }}>
    //                 {toPrice(record.amount)}
    //             </span>
    //         ),
    //     },
    //     {
    //         title: "",
    //         width: "5%",
    //         dataIndex: "action",
    //         render: (text, record) =>
    //             <GenericDropdown dropdownItems={[

    //                 record.is_live_link ?
    //                     <div
    //                         style={{
    //                             color: "#0096FF",
    //                             cursor: "pointer",
    //                         }}
    //                         onClick={(event) => {
    //                             event.stopPropagation();
    //                             navigator.clipboard.writeText(record.url);
    //                             message.success("Link copied to clipboard.");
    //                         }}
    //                     >
    //                         Copy Link
    //                     </div>
    //                     : undefined,

    //                 <div
    //                     style={{ color: "red", cursor: "pointer", }}
    //                     onClick={(event) => {
    //                         event.stopPropagation();
    //                         setVisibleCancelModal(true);
    //                         setCancelRequestId(record.id);
    //                     }}
    //                 >
    //                     Cancel
    //                 </div>
    //             ]} />
    //     }
    // ];

    const totalTableWidth = table_columns.reduce((totalWidth, column) => {
        return totalWidth + parseFloat(column.width || 0);
    }, 0);

    const firstColumnWidthFraction = parseFloat(table_columns[0].width || 0) / totalTableWidth;
    const expandableOffset = Math.ceil(firstColumnWidthFraction * 100);

    const expandableConfig = {
        expandedRowRender: (record) =>
            <TransactionsDrawerSimple
                selectedTransactionData={selectedAchDebitRequestData}
                offset={expandableOffset}
            />,
        expandRowByClick: true,
        onExpand: handleExpand,
        expandedRowKeys: expandedRowKeys,
        expandIconColumnIndex: -1,
    };


    let exportdata = [];
    for (var i = 0; i < props.achDebitRequests.length; i++) {
        var item = props.achDebitRequests[i];
        var data = {
            date: item.timestamp.split("T")[0],
            description: item.payee_info.memo + " | " + item.payee_info.name,
            method: "ACH",
            amount:
                item.amount >= 0
                    ? `$${parseFloat(item.amount).toFixed(2)}`
                    : `- $${parseFloat(
                        Math.abs(item.amount)
                    ).toFixed(2)}`,
        };
        exportdata.push(data);
    }

    const TransactionDrawerX = () => (
        <TransactionsDrawerSimple
            selectedTransactionData={selectedAchDebitRequestData}
            offset={expandableOffset}
        />
    );

    return (
        <Space direction="vertical" style={{ width: "100%" }}>
            {/*  Table Filters */}
            <TransactionTableFilters
                handleSearch={handleSearch}
                handleDateFilter={handleDateFilter}
                dateRangeFilter={dateRangeFilter}
                exportdata={exportdata}
                bankAccountName={''}
            />
            <GenericTableOnRowOnClick1
                // pagination={{
                //     className: "card-table-pagination",
                //     defaultPageSize: 50,
                //     showSizeChanger: true,
                // }}
                pagination={{
                    paginationModel: { pageSize: showAchDebitRequests?.length || 10, page: 0 },
                }}
                pageSizeOptions={[5, 10, 25]}
                sortModel={[
                    {
                        field: "timestamp",
                        sort: "desc",
                    },
                ]}
                columns={table_columns}
                dataSource={showAchDebitRequests}
                style={{ cursor: "pointer" }}
                numerator={props.numerator}
                denominator={props.denominator}
                loading={props.loadingAchDebitRequests}
                transactionDrawerComponent={TransactionDrawerX}
                enableExpandable={true}
                handleExpand={handleExpand}
            />
            {/* <GenericTableOnRowOnClick
                pagination={{
                    className: "card-table-pagination",
                    defaultPageSize: 50,
                    showSizeChanger: true,
                }}
                columns={table_columns}
                dataSource={showAchDebitRequests}
                style={{ cursor: "pointer" }}
                loading={props.loadingAchDebitRequests}
                expandableConfig={expandableConfig}
            /> */}
            <GenericModal
                size='sm'
                visible={visibleCancelModal}
                handleCancelModal={() => setVisibleCancelModal(false)}
                showModal={() => setVisibleCancelModal(true)}
                modalTitle={'Cancel ACH Debit Request'}
                modalBody={
                    <Form
                        layout="vertical"
                        name="basic"
                        autoComplete="off"
                    >
                        <Form.Item>
                            <Typography style={{ fontSize: "16px" }}>
                                Are you sure you want to cancel this request?
                            </Typography>
                        </Form.Item>
                        <Form.Item
                            style={{
                                display: "flex",
                                flexDirection: "row",
                            }}>
                            <Button
                                disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                                style={{ marginRight: "25px", width: "40%" }}
                                sx={{ fontSize: 12, width: '100%', textTransform: 'none' }}
                                onClick={() => {
                                    setVisibleCancelModal(false);
                                    cancelRequest(cancelRequestId);
                                }}
                            >
                                Yes
                            </Button>
                            <Button
                                disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary"
                                style={{ marginLeft: "25px", width: "40%" }}
                                sx={{ fontSize: 12, width: '100%', textTransform: 'none' }}
                                onClick={() => {
                                    setVisibleCancelModal(false);
                                }}
                            >
                                No
                            </Button>
                        </Form.Item>
                    </Form>
                }
            />
        </Space>
    );
}

export default AchDebitRequests;
